import { html } from "lit";

export const formMockHtml = html`
    <div
        id="c968536"
        class="frame frame-default frame-type-form_formframework frame-layout-201"
    >
        <header></header>

        <div class="tx-powermail powermail_norm">
            <div class="ux-row ux-u-flex-jc-center">
                <div
                    class="ux-col-11 ux-col-sm-10 ux-col-md-6 powermail_container"
                >
                    <form
                        autocomplete="on"
                        enctype="multipart/form-data"
                        method="post"
                        class="powermail_form powermail_form_webinarTestform-968536 form-horizontal"
                        id="webinarTestform-968536"
                        action="./mock-data/webinar/form-success.html"
                    >
                        <div>
                            <input
                                type="hidden"
                                name="tx_form_formframework[webinarTestform-968536][__state]"
                                value="TzozOToiVFlQTzNcQ01TXEZvcm1cRG9tYWluXFJ1bnRpbWVcRm9ybVN0YXRlIjoyOntzOjI1OiIAKgBsYXN0RGlzcGxheWVkUGFnZUluZGV4IjtpOjA7czoxMzoiACoAZm9ybVZhbHVlcyI7YTowOnt9fQ==2094dad0ff5fac95ca14ef58d1b59ee80363b4f0"
                            /><input
                                type="hidden"
                                name="tx_form_formframework[__trustedProperties]"
                                value='{"webinarTestform-968536":{"radiobutton-1":1,"salutation":1,"firstname":1,"lastname":1,"company":1,"streetno":1,"zip":1,"place":1,"countrylist":1,"email":1,"message":1,"newsletter":1,"additionalinfo":1,"Fr8HmIkPXOARgs":1,"__currentPage":1},"countrylist":1}4011c143fcf6142c549a505290a10f6d3d37cf6c'
                            />
                        </div>

                        <div class="powermail_fieldset">
                            <div class="ax_default heading_2">
                                <div class="text">
                                    <p><span>Ihre Daten</span></p>
                                </div>
                            </div>

                            <div
                                class="powermail_fieldwrap powermail_fieldwrap_type_radio no-gutter-left form-group  gr-12"
                            >
                                <label
                                    class="control-label powermail_fieldwrap__label powermail_label label-errorMsg"
                                    for="webinarTestform-968536-radiobutton-1"
                                >
                                    Date

                                    <span class="required">*</span>
                                </label>

                                <div class="powermail_field">
                                    <div
                                        id="webinarTestform-968536-radiobutton-1"
                                        class="inputs-list"
                                    >
                                        <div class="form-group">
                                            <label
                                                class="radio"
                                                for="webinarTestform-968536-radiobutton-1-0"
                                            >
                                                <span
                                                    class="radio-wrapper radio"
                                                >
                                                    <input
                                                        required="required"
                                                        data-parsley-required-message="Dieses Feld muss ausgefüllt werden!"
                                                        class="xlarge form-check-input"
                                                        id="webinarTestform-968536-radiobutton-1-0"
                                                        type="radio"
                                                        name="tx_form_formframework[webinarTestform-968536][radiobutton-1]"
                                                        value="1743002907"
                                                    />
                                                    <span
                                                        class="radio-icon"
                                                    ></span>
                                                </span>
                                                <span class="radio-label"
                                                    >Date_1</span
                                                >
                                            </label>

                                            <label
                                                class="radio"
                                                for="webinarTestform-968536-radiobutton-1-1"
                                            >
                                                <span
                                                    class="radio-wrapper radio"
                                                >
                                                    <input
                                                        required="required"
                                                        data-parsley-required-message="Dieses Feld muss ausgefüllt werden!"
                                                        class="xlarge form-check-input"
                                                        id="webinarTestform-968536-radiobutton-1-1"
                                                        type="radio"
                                                        name="tx_form_formframework[webinarTestform-968536][radiobutton-1]"
                                                        value="1743002908"
                                                    />
                                                    <span
                                                        class="radio-icon"
                                                    ></span>
                                                </span>
                                                <span class="radio-label"
                                                    >Date_2</span
                                                >
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div
                                class="powermail_fieldwrap no-gutter-left form-group  gr-6 gr-12@m"
                            >
                                <label
                                    class="control-label powermail_fieldwrap__label powermail_label label-errorMsg"
                                    for="webinarTestform-968536-salutation"
                                >
                                    Anrede
                                </label>

                                <div class="select select-field">
                                    <span
                                        class="icon-arrow_down select-icon"
                                    ></span>

                                    <select
                                        data-parsley-required-message="Dieses Feld muss ausgefüllt werden!"
                                        class="powermail_field form-control "
                                        id="powermail_field_webinarTestform-968536-salutation"
                                        name="tx_form_formframework[webinarTestform-968536][salutation]"
                                    >
                                        <option value="">
                                            Bitte wählen ...
                                        </option>
                                        <option value="2">Herr</option>
                                        <option value="1">Frau</option>
                                        <option value="3">Divers</option>
                                    </select>
                                </div>
                            </div>

                            <div
                                class="powermail_fieldwrap powermail_fieldwrap_type_gap no-gutter-left gr-6 gr-12@m"
                            ></div>

                            <div
                                class="powermail_fieldwrap no-gutter-left form-group  gr-6 gr-12@m"
                            >
                                <label
                                    class="control-label powermail_fieldwrap__label powermail_label label-errorMsg"
                                    for="webinarTestform-968536-firstname"
                                >
                                    Vorname
                                </label>

                                <div class="powermail_fieldwrap input">
                                    <input
                                        data-parsley-required-message="Dieses Feld muss ausgefüllt werden!"
                                        class=" form-control"
                                        id="webinarTestform-968536-firstname"
                                        type="text"
                                        name="tx_form_formframework[webinarTestform-968536][firstname]"
                                        value=""
                                    />
                                </div>
                            </div>

                            <div
                                class="powermail_fieldwrap no-gutter-left form-group  gr-6 gr-12@m"
                            >
                                <label
                                    class="control-label powermail_fieldwrap__label powermail_label label-errorMsg"
                                    for="webinarTestform-968536-lastname"
                                >
                                    Nachname
                                </label>

                                <div class="powermail_fieldwrap input">
                                    <input
                                        data-parsley-required-message="Dieses Feld muss ausgefüllt werden!"
                                        class=" form-control"
                                        id="webinarTestform-968536-lastname"
                                        type="text"
                                        name="tx_form_formframework[webinarTestform-968536][lastname]"
                                        value=""
                                    />
                                </div>
                            </div>

                            <div
                                class="powermail_fieldwrap no-gutter-left form-group  gr-12"
                            >
                                <label
                                    class="control-label powermail_fieldwrap__label powermail_label label-errorMsg"
                                    for="webinarTestform-968536-company"
                                >
                                    Firma
                                </label>

                                <div class="powermail_fieldwrap input">
                                    <input
                                        data-parsley-required-message="Dieses Feld muss ausgefüllt werden!"
                                        class=" form-control"
                                        id="webinarTestform-968536-company"
                                        type="text"
                                        name="tx_form_formframework[webinarTestform-968536][company]"
                                        value=""
                                    />
                                </div>
                            </div>

                            <div
                                class="powermail_fieldwrap no-gutter-left form-group  gr-12"
                            >
                                <label
                                    class="control-label powermail_fieldwrap__label powermail_label label-errorMsg"
                                    for="webinarTestform-968536-streetno"
                                >
                                    Straße und Nr.
                                </label>

                                <div class="powermail_fieldwrap input">
                                    <input
                                        data-parsley-required-message="Dieses Feld muss ausgefüllt werden!"
                                        class=" form-control"
                                        id="webinarTestform-968536-streetno"
                                        type="text"
                                        name="tx_form_formframework[webinarTestform-968536][streetno]"
                                        value=""
                                    />
                                </div>
                            </div>

                            <div
                                class="powermail_fieldwrap no-gutter-left form-group  gr-12"
                            >
                                <label
                                    class="control-label powermail_fieldwrap__label powermail_label label-errorMsg"
                                    for="webinarTestform-968536-zip"
                                >
                                    PLZ
                                </label>

                                <div class="powermail_fieldwrap input">
                                    <input
                                        data-parsley-required-message="Dieses Feld muss ausgefüllt werden!"
                                        class=" form-control"
                                        id="webinarTestform-968536-zip"
                                        type="text"
                                        name="tx_form_formframework[webinarTestform-968536][zip]"
                                        value=""
                                    />
                                </div>
                            </div>

                            <div
                                class="powermail_fieldwrap no-gutter-left form-group  gr-12"
                            >
                                <label
                                    class="control-label powermail_fieldwrap__label powermail_label label-errorMsg"
                                    for="webinarTestform-968536-place"
                                >
                                    Ort
                                </label>

                                <div class="powermail_fieldwrap input">
                                    <input
                                        data-parsley-required-message="Dieses Feld muss ausgefüllt werden!"
                                        class=" form-control"
                                        id="webinarTestform-968536-place"
                                        type="text"
                                        name="tx_form_formframework[webinarTestform-968536][place]"
                                        value=""
                                    />
                                </div>
                            </div>

                            <div
                                class="powermail_fieldwrap powermail_fieldwrap_type_select powermail_fieldwrap_countrylist no-gutter-left gr-12"
                            >
                                <label
                                    for="powermail_field_118937_webinarTestform-968536-countrylist"
                                    class="powermail_fieldwrap__label  label-errorMsg"
                                    title=""
                                >
                                    Land/Region
                                </label>

                                <div class="powermail_fieldwrap">
                                    <input
                                        readonly="readonly"
                                        onfocus="this.removeAttribute(&#039;readonly&#039;);"
                                        class="select select-field powermail_field_countrylist  form-control"
                                        id="powermail_field_118937_webinarTestform-968536-countrylist"
                                        type="text"
                                        name="tx_form_formframework[countrylist]"
                                    />
                                    <datalist id="countries_118937">
                                        <select style="display:none;">
                                            <option value="AL">Albanien</option>

                                            <option value="DZ">Algerien</option>

                                            <option value="AR">
                                                Argentinien
                                            </option>

                                            <option value="AU">
                                                Australien
                                            </option>

                                            <option value="BH">Bahrain</option>

                                            <option value="BE">Belgien</option>

                                            <option value="BR">
                                                Brasilien
                                            </option>

                                            <option value="BG">
                                                Bulgarien
                                            </option>

                                            <option value="CL">Chile</option>

                                            <option value="CN">China</option>

                                            <option value="CR">
                                                Costa Rica
                                            </option>

                                            <option value="DE" selected>
                                                Deutschland
                                            </option>

                                            <option value="DK">Dänemark</option>

                                            <option value="EE">Estland</option>

                                            <option value="FI">Finnland</option>

                                            <option value="FR">
                                                Frankreich
                                            </option>

                                            <option value="GR">
                                                Griechenland
                                            </option>

                                            <option value="IN">Indien</option>

                                            <option value="ID">
                                                Indonesien
                                            </option>

                                            <option value="IQ">Irak</option>

                                            <option value="IR">Iran</option>

                                            <option value="IE">Irland</option>

                                            <option value="IS">Island</option>

                                            <option value="IL">Israel</option>

                                            <option value="IT">Italien</option>

                                            <option value="JP">Japan</option>

                                            <option value="JO">
                                                Jordanien
                                            </option>

                                            <option value="KH">
                                                Kambodscha
                                            </option>

                                            <option value="CA">Kanada</option>

                                            <option value="QA">Katar</option>

                                            <option value="KE">Kenia</option>

                                            <option value="CO">
                                                Kolumbien
                                            </option>

                                            <option value="HR">Kroatien</option>

                                            <option value="KW">Kuwait</option>

                                            <option value="LV">Lettland</option>

                                            <option value="LB">Libanon</option>

                                            <option value="LI">
                                                Liechtenstein
                                            </option>

                                            <option value="LT">Litauen</option>

                                            <option value="LU">
                                                Luxemburg
                                            </option>

                                            <option value="MY">Malaysia</option>

                                            <option value="MT">Malta</option>

                                            <option value="MA">Marokko</option>

                                            <option value="MX">Mexiko</option>

                                            <option value="MM">Myanmar</option>

                                            <option value="NZ">
                                                Neuseeland
                                            </option>

                                            <option value="NL">
                                                Niederlande
                                            </option>

                                            <option value="MK">
                                                Nordmazedonien
                                            </option>

                                            <option value="NO">Norwegen</option>

                                            <option value="PK">Pakistan</option>

                                            <option value="PS">
                                                Palästinensische
                                                Autonomiegebiete
                                            </option>

                                            <option value="PE">Peru</option>

                                            <option value="PH">
                                                Philippinen
                                            </option>

                                            <option value="PL">Polen</option>

                                            <option value="PT">Portugal</option>

                                            <option value="RO">Rumänien</option>

                                            <option value="RU">Russland</option>

                                            <option value="SA">
                                                Saudi-Arabien
                                            </option>

                                            <option value="SE">Schweden</option>

                                            <option value="CH">Schweiz</option>

                                            <option value="RS">Serbien</option>

                                            <option value="SG">Singapur</option>

                                            <option value="SK">Slowakei</option>

                                            <option value="SI">
                                                Slowenien
                                            </option>

                                            <option value="HK">
                                                Sonderverwaltungsregion Hongkong
                                            </option>

                                            <option value="ES">Spanien</option>

                                            <option value="SY">Syrien</option>

                                            <option value="ZA">
                                                Südafrika
                                            </option>

                                            <option value="KR">Südkorea</option>

                                            <option value="TW">Taiwan</option>

                                            <option value="TH">Thailand</option>

                                            <option value="CZ">
                                                Tschechien
                                            </option>

                                            <option value="TN">Tunesien</option>

                                            <option value="TR">Türkei</option>

                                            <option value="UA">Ukraine</option>

                                            <option value="HU">Ungarn</option>

                                            <option value="UY">Uruguay</option>

                                            <option value="VE">
                                                Venezuela
                                            </option>

                                            <option value="AE">
                                                Vereinigte Arabische Emirate
                                            </option>

                                            <option value="US">
                                                Vereinigte Staaten
                                            </option>

                                            <option value="GB">
                                                Vereinigtes Königreich
                                            </option>

                                            <option value="VN">Vietnam</option>

                                            <option value="EG">Ägypten</option>

                                            <option value="AT">
                                                Österreich
                                            </option>

                                            <option value="OO">Andere</option>
                                        </select>
                                    </datalist>
                                    <span class="hide">
                                        <input
                                            data-parsley-required-message="Dieses Feld muss ausgefüllt werden!"
                                            class="select select-field"
                                            id="countryiso_118937"
                                            type="text"
                                            name="tx_form_formframework[webinarTestform-968536][countrylist]"
                                            value=""
                                        />
                                    </span>
                                </div>
                            </div>
                            <script>
                                var mandatory = false;
                                var inputCountriesName = "countrylist";
                                var hiddenFieldId = "118937";
                                if (typeof formId === "undefined") {
                                    var formId = ["118937"];
                                } else {
                                    formId.push("118937");
                                }

                                var availableCountries = [];
                                availableCountries["AL"] = "Albanien";
                                availableCountries["DZ"] = "Algerien";
                                availableCountries["AR"] = "Argentinien";
                                availableCountries["AU"] = "Australien";
                                availableCountries["BH"] = "Bahrain";
                                availableCountries["BE"] = "Belgien";
                                availableCountries["BR"] = "Brasilien";
                                availableCountries["BG"] = "Bulgarien";
                                availableCountries["CL"] = "Chile";
                                availableCountries["CN"] = "China";
                                availableCountries["CR"] = "Costa Rica";
                                availableCountries["DE"] = "Deutschland";
                                availableCountries["DK"] = "Dänemark";
                                availableCountries["EE"] = "Estland";
                                availableCountries["FI"] = "Finnland";
                                availableCountries["FR"] = "Frankreich";
                                availableCountries["GR"] = "Griechenland";
                                availableCountries["IN"] = "Indien";
                                availableCountries["ID"] = "Indonesien";
                                availableCountries["IQ"] = "Irak";
                                availableCountries["IR"] = "Iran";
                                availableCountries["IE"] = "Irland";
                                availableCountries["IS"] = "Island";
                                availableCountries["IL"] = "Israel";
                                availableCountries["IT"] = "Italien";
                                availableCountries["JP"] = "Japan";
                                availableCountries["JO"] = "Jordanien";
                                availableCountries["KH"] = "Kambodscha";
                                availableCountries["CA"] = "Kanada";
                                availableCountries["QA"] = "Katar";
                                availableCountries["KE"] = "Kenia";
                                availableCountries["CO"] = "Kolumbien";
                                availableCountries["HR"] = "Kroatien";
                                availableCountries["KW"] = "Kuwait";
                                availableCountries["LV"] = "Lettland";
                                availableCountries["LB"] = "Libanon";
                                availableCountries["LI"] = "Liechtenstein";
                                availableCountries["LT"] = "Litauen";
                                availableCountries["LU"] = "Luxemburg";
                                availableCountries["MY"] = "Malaysia";
                                availableCountries["MT"] = "Malta";
                                availableCountries["MA"] = "Marokko";
                                availableCountries["MX"] = "Mexiko";
                                availableCountries["MM"] = "Myanmar";
                                availableCountries["NZ"] = "Neuseeland";
                                availableCountries["NL"] = "Niederlande";
                                availableCountries["MK"] = "Nordmazedonien";
                                availableCountries["NO"] = "Norwegen";
                                availableCountries["PK"] = "Pakistan";
                                availableCountries["PS"] =
                                    "Palästinensische Autonomiegebiete";
                                availableCountries["PE"] = "Peru";
                                availableCountries["PH"] = "Philippinen";
                                availableCountries["PL"] = "Polen";
                                availableCountries["PT"] = "Portugal";
                                availableCountries["RO"] = "Rumänien";
                                availableCountries["RU"] = "Russland";
                                availableCountries["SA"] = "Saudi-Arabien";
                                availableCountries["SE"] = "Schweden";
                                availableCountries["CH"] = "Schweiz";
                                availableCountries["RS"] = "Serbien";
                                availableCountries["SG"] = "Singapur";
                                availableCountries["SK"] = "Slowakei";
                                availableCountries["SI"] = "Slowenien";
                                availableCountries["HK"] =
                                    "Sonderverwaltungsregion Hongkong";
                                availableCountries["ES"] = "Spanien";
                                availableCountries["SY"] = "Syrien";
                                availableCountries["ZA"] = "Südafrika";
                                availableCountries["KR"] = "Südkorea";
                                availableCountries["TW"] = "Taiwan";
                                availableCountries["TH"] = "Thailand";
                                availableCountries["CZ"] = "Tschechien";
                                availableCountries["TN"] = "Tunesien";
                                availableCountries["TR"] = "Türkei";
                                availableCountries["UA"] = "Ukraine";
                                availableCountries["HU"] = "Ungarn";
                                availableCountries["UY"] = "Uruguay";
                                availableCountries["VE"] = "Venezuela";
                                availableCountries["AE"] =
                                    "Vereinigte Arabische Emirate";
                                availableCountries["US"] = "Vereinigte Staaten";
                                availableCountries["GB"] =
                                    "Vereinigtes Königreich";
                                availableCountries["VN"] = "Vietnam";
                                availableCountries["EG"] = "Ägypten";
                                availableCountries["AT"] = "Österreich";
                                availableCountries["OO"] = "Andere";
                                require([
                                    "minified/form/_countrylist.min",
                                ], function (countrylist) {
                                    countrylist.init();
                                    var countryVal = $(
                                        "#countryiso_" + hiddenFieldId
                                    ).val();
                                    if (countryVal) {
                                        $(
                                            ".powermail_field_" +
                                                inputCountriesName
                                        ).val(availableCountries[countryVal]);
                                    }
                                });
                            </script>

                            <div
                                class="powermail_fieldwrap no-gutter-left form-group  gr-12"
                            >
                                <label
                                    class="control-label powermail_fieldwrap__label powermail_label label-errorMsg"
                                    for="webinarTestform-968536-email"
                                >
                                    E-Mail

                                    <span class="required">*</span>
                                </label>

                                <div class="powermail_fieldwrap input">
                                    <input
                                        data-parsley-required-message="Dieses Feld muss ausgefüllt werden!"
                                        class=" form-control"
                                        id="webinarTestform-968536-email"
                                        type="text"
                                        name="tx_form_formframework[webinarTestform-968536][email]"
                                        value=""
                                    />
                                </div>
                            </div>

                            <div
                                class="powermail_fieldwrap no-gutter-left form-group  gr-12"
                            >
                                <label
                                    class="control-label powermail_fieldwrap__label powermail_label label-errorMsg"
                                    for="webinarTestform-968536-message"
                                >
                                    Ihre Nachricht

                                    <span class="required">*</span>
                                </label>

                                <div class="powermail_fieldwrap input">
                                    <textarea
                                        placeholder=""
                                        data-parsley-required-message="Dieses Feld muss ausgefüllt werden!"
                                        rows="5"
                                        cols="20"
                                        class="xxlarge form-control"
                                        id="webinarTestform-968536-message"
                                        name="tx_form_formframework[webinarTestform-968536][message]"
                                    ></textarea>
                                </div>
                            </div>

                            <div
                                class="powermail_fieldwrap no-gutter-left form-group  gr-12"
                            >
                                <div class="powermail_fieldwrap input">
                                    <div
                                        class="form-check powermail_fieldwrap_type_check powermail_newsletter_subscription no-gutter-left gr-12"
                                    >
                                        <input
                                            type="hidden"
                                            name="tx_form_formframework[webinarTestform-968536][newsletter]"
                                            value=""
                                        /><input
                                            data-parsley-required-message="Dieses Feld muss ausgefüllt werden!"
                                            class="add-on powermail_input"
                                            id="powermail_field_newsletter_0"
                                            type="checkbox"
                                            name="tx_form_formframework[webinarTestform-968536][newsletter]"
                                            value="1"
                                        />
                                        <label
                                            for="checkbox"
                                            class="label_newsletter_subscription label-errorMsg"
                                        >
                                            Ich bin damit einverstanden, dass
                                            die TRUMPF Gruppe meine zuvor
                                            angegebenen Daten zum Zwecke der
                                            Marktforschung, Werbung und Analyse
                                            verarbeitet und mich zu diesen
                                            Zwecken per Post, E-Mail und Telefon
                                            kontaktiert, um mich über eigene
                                            aktuelle Angebote und Services zu
                                            informieren. <br /><br />Ich kann
                                            diese Einwilligung jederzeit, auch
                                            teilweise, unter
                                            <a
                                                href="mailto:mailings_holding@de.trumpf.com"
                                                >mailings_holding@de.trumpf.com</a
                                            >
                                            widerrufen.
                                            <br />
                                            <span
                                                class="powermail_field_error_container powermail_field_error_container_ label-errorMsg"
                                            ></span>
                                            <br />
                                            Mehr zum Thema Datenschutz bei
                                            TRUMPF finden Sie in unserer
                                            <a href="/de_INT/meta/datenschutz/"
                                                >Datenschutzerklärung</a
                                            >.

                                            <br />
                                        </label>
                                    </div>

                                    <br />
                                </div>
                            </div>

                            <input
                                id="webinarTestform-968536-additionalinfo"
                                type="hidden"
                                name="tx_form_formframework[webinarTestform-968536][additionalinfo]"
                                value='{"pageUid":2920,"referrer":"http%3A%2F%2Ftrumpf.local.tru%2Ftypo3%2Fmodule%2Fweb%2Flayout","siteurl":"http%3A%2F%2Ftrumpf.local.tru%2Fde_INT%2Fcontent-elemente%2F","ttContentUid":968536}'
                            />

                            <input
                                autocomplete="Fr8HmIkPXOARgs"
                                aria-hidden="true"
                                id="webinarTestform-968536-Fr8HmIkPXOARgs"
                                style="position:absolute; margin:0 0 0 -999em;"
                                tabindex="-1"
                                type="text"
                                name="tx_form_formframework[webinarTestform-968536][Fr8HmIkPXOARgs]"
                            />
                        </div>

                        <div class="actions">
                            <ux-iws-form-loader
                                loader-target=".ux-button"
                                loader-margin-offset="10"
                            ></ux-iws-form-loader>
                            <nav class="form-navigation ux-u-mt-xxs">
                                <div class="ux-row">
                                    <div
                                        class="ux-col-12 ux-u-text-align--center"
                                    >
                                        <div
                                            class="ux-button-group ux-button-group--with-spacing"
                                        >
                                            <button
                                                data-tracking-form-submit=""
                                                class="ux-button ux-button--green ux-u-margin-bottom-15"
                                                style="order: 1"
                                                type="submit"
                                                name="tx_form_formframework[webinarTestform-968536][__currentPage]"
                                                value="1"
                                            >
                                                Absenden
                                            </button>

                                            <input
                                                id="current-page"
                                                type="hidden"
                                                name="tx_form_formframework[webinarTestform-968536][__currentPage]"
                                                value="1"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </nav>
                        </div>

                        <ux-u-privacy-form-protect
                            class="ux-u-my-xxs"
                            message="You must accept the data privacy policy in order to submit this form"
                        ></ux-u-privacy-form-protect>
                    </form>
                    <div class="u-clearfix"></div>
                </div>
            </div>
        </div>
        <script>
            require(["minified/externalJs.min"], function (externalJs) {
                externalJs.addExternalJs("minified/form/_form.min");
            });
        </script>
    </div>
`;
